import { Outlet } from 'react-router-dom';

const AuthShell = () => <Outlet />;

export default AuthShell;
